import gsap from 'gsap';
import { Group } from 'three';

import { CLOUDS_TRANSITION_STAGE } from 'state/threeStore';

import * as U from './CloudTransition.utils';

const ANIMATIONS: Record<
  CLOUDS_TRANSITION_STAGE,
  ((group: Group) => gsap.core.Timeline) | undefined
> = {
  HIDDEN: undefined,
  INTRO: group =>
    gsap
      .timeline()
      .call(() => {
        group.visible = true;
      })
      .to(U.findTransparentMaterials(group), {
        opacity: 1,
        duration: 0.1,
      })
      .to(U.findTransparentMaterials(group), {
        opacity: 0,
        duration: 10,
      })
      .call(() => {
        group.visible = false;
      }),

  OUTRO: group =>
    gsap
      .timeline()
      .call(() => {
        group.visible = true;
      })
      .to(U.findTransparentMaterials(group), {
        opacity: 1,
        duration: 2.8,
      })
      .to(U.findTransparentMaterials(group), {
        opacity: 0,
        duration: 0.2,
      })
      .call(() => {
        group.visible = false;
      }),
};

export default ANIMATIONS;
